// extracted by mini-css-extract-plugin
export var active = "_8c-a";
export var activeIndicator = "_8c-9";
export var disabled = "_8c-b";
export var fullWidth = "_8c-2";
export var lg = "_8c-7";
export var md = "_8c-6";
export var redoButtonTabGroup = "_8c-0";
export var sm = "_8c-5";
export var tabButton = "_8c-4";
export var tabButtonsContainer = "_8c-1";
export var themeDestructive = "_8c-d";
export var themeNormal = "_8c-c";
export var themeSuccess = "_8c-e";
export var xl = "_8c-8";
export var xs = "_8c-3";